// Use window.$ directly to avoid timing issues with jQuery loading
var $ = window.$ || window.jQuery;

function initItemForm() {
  console.log('>>>> initItemForm');
  var products = JSON.parse($('#products').val());
  var work_type = $('#work_type').val();
  var product_id = $('#product_id').val();
  var generic_product_id = $('#generic_product_id').val();
  
  $('input.currency').currencyInput();

  $('#item_quantity, #item_ups, #item_paper_id').on('change', calculate_sheets);

  $('#item_product_id').on('change', function() {
    toggle_product_elements();
    get_product();
    calculate_costs();
  });

  $('.recalculate').on('change', calculate_costs);

  $('#cancel-button').on('click', function() {
    $('#item-form').foundation('close');
  });
  
  build_product_menu(work_type, product_id, generic_product_id);
  toggle_product_elements();
  calculate_costs();

  function get_product() {
    var product_id = $('#item_product_id').val();
    
    $.get(
      '/products/' + product_id + '/paper',
      function(data) {
        $('#item_paper_id').val(data.paper_id);
        $('#item_design_fee').val(data.design_fee);
        $('#setup_percentage').val(data.setup_percentage);
        $('#item_base_cost').val(data.base_cost);
        $('#item_markup').val(data.markup);
        $('#item_cost_factor').val(data.cost_factor);

        if($('#item_paper_id').val() != 0) {
          $('#item_ups').val(data.ups);
        } else {
          $('#item_ups').val(1);
        }
        calculate_sheets();
      }
    );
  }

  function calculate_costs() {
    var item = get_item();
    
    if(item.product_id != '') {
      $.post(
        '/items/calculate_vendor_cost/', { item: item },
        function(data) {
          $('#item_vendor_cost').val(data.cost);
          calculate_subtotal();
        }
      )
    }
  }
  
  function calculate_subtotal() {
    var item = get_item();
    var quantity = $('#item_quantity').val();
    var hours = $('#item_hours').val();
    
    $.post(
      '/items/calculate_subtotal/', { item: item },
      function(data) {
        $('#subtotal').val(data.subtotal);
        if(quantity > 0) {
          $('#unit_subtotal').html('(' + (data.subtotal/quantity).toPrecision(3) + '/unit)');
        } else {
          if(hours > 0) {
            $('#unit_subtotal').html('(' + (data.subtotal/hours).toPrecision(3) + '/hour)');
          } else {
            $('#unit_subtotal').html('');
          }
        }
      }
    )
  }
  
  function build_product_menu(work_type, product_id) {
    var new_options = '';
    
    if(work_type == undefined) {
      work_type == 'Job';
    }
    
    new_options = new_options + '<option value="">Select...</option>';
    
    if(work_type == 'Project' || work_type == 'Retainer' || work_type == 'Estimate') {
      new_options = new_options + $.map(products, function(product) {
        var option;
        if(product.kind == 'Hourly' || product.kind == 'Generic') {
          option = '<option data-product-type="' + product.kind + '" data-product-vendor="' + product.vendor_id + '" value="' + product.id + '">' + product.name + '</option>';
        }
        return option;
      });
    } else if(work_type == 'Job' || work_type == 'Quote') {
      new_options = new_options + $.map(products, function(product) {
        var option;
        if(product.kind == 'Paper' || product.kind == 'Screen' || product.kind == 'Garment' || product.kind == 'Generic') {
          option = '<option data-product-type="' + product.kind + '" data-product-vendor="' + product.vendor_id + '" value="' + product.id + '">' + product_name(product) + '</option>';
        }
        return option;
      });
    }
    
    $('#item_product_id').empty();
    $('#item_product_id').html(new_options);
    $('#item_product_id').val(product_id);
    $('#item_product_id').addClass('recalculate');
  }
  
  function product_name(product) {
    if(product.vendor_id) {
      return product.name + ' - ' + product.vendor.name
    } else {
      return product.name
    }
  }
  
  function toggle_product_elements() {
    console.log('toggle_product_elements');
    var product_type = $('#item_product_id option:selected').data('product-type');
    var print_elements = $('.print-product');
    var hourly_elements = $('.hourly-product');
    var generic_elements = $('.generic-product');
    var paper_elements = $('.paper-product');
    
    if(product_type == undefined) {
      if($('#work_type').val() == 'Project' || $('#work_type').val() == 'Retainer' || $('#work_type').val() == 'Estimate') {
        $('.print-product, .generic-product, .paper-product').hide();
        $('.hourly-product').show();
      } else {
        $('.hourly-product, .generic-product, .paper-product, .retainer-element').hide();
        $('.print-product, .product_type').show();
      }
    } else if(product_type == 'Paper') {
      $('.hourly-product, .generic-product, .retainer-element').hide();
      $('.print-product, .paper-product').show();
    } else if(product_type == 'Screen' || product_type == 'Garment') {
      $('.hourly-product, .generic-product, .paper-product').hide();
      $('.print-product').show();
      $(product_type).show();
    } else if(product_type == 'Generic') {
      $('.print-product, .hourly-product, .paper-product, .retainer-element').hide();
      $('.generic-product').show();
    } else {
      $('.paper-product, .print-product, .generic-product').hide();
      $('.hourly-product').show();
    }
  }
  
  function calculate_sheets() {
    var quantity = 1;
    var ups = 1;
    var sheets = 0;
    var setup_percentage = $('#setup_percentage').val();

    if($('#item_quantity').val() != '') {
      quantity = $('#item_quantity').val();
    }

    if($('#item_ups').val() != '') {
      ups = $('#item_ups').val();
    }

    sheets = Math.ceil(parseInt(quantity)/parseInt(ups));

    if(setup_percentage || setup_percentage == 0) {
      setup_percentage = (setup_percentage / 100) + 1;
      sheets = Math.ceil(sheets * setup_percentage);
    } else {
      sheets = Math.ceil(sheets * 1.05);
    }

    $('#item_sheets').val(sheets);
  }

  function get_item() {
    var item = {};
    item.work_id = $('#work_id').val();
    item.quantity = $('#item_quantity').val();
    item.hours = $('#item_hours').val();
    item.units = $('#item_units').val();
    item.unit_costs = $('#item_unit_costs').val();
    item.sheets = $('#item_sheets').val();
    item.product_id = $('#item_product_id').val();
    item.paper_id = $('#item_paper_id').val();
    item.cost_factor = $('#item_cost_factor').val();
    item.base_cost = $('#item_base_cost').val();
    item.markup = $('#item_markup').val();
    item.design_fee = $('#item_design_fee').val();
    item.has_bleed = $('#item_has_bleed:checked').val();
    item.is_one_sided = $('#item_is_one_sided:checked').val();
    item.has_cutting = $('#item_has_cutting:checked').val();
    item.has_folding = $('#item_has_folding:checked').val();
    item.mail_merge = $('#item_mail_merge:checked').val();
    item.mail_merge_amount = $('#item_mail_merge_amount').val();

    return item;
  }

  $('form.item-form').on('submit', function() {
    $('.item-form input[type="submit"]').attr('disabled', true);
    show_spinner('#item-form');
    return true;
  });
  
  $('.print-rule-out').on('click', function() {
    $('#rule-out').printThis({
      importCSS: true,
      importStyle: true,
    });
    return false;
  });
}

// Expose globally for Rails UJS templates
window.initItemForm = initItemForm;

function initDragDropArtwork(itemId) {
  var drop = $("li#item-" + itemId)[0];
  if (!drop) return;
  
  var original_color = $(drop).css('background-color');
  var original_border = $(drop).css('border');
  var url = "/items/" + $(drop).data('item-id') + "/add_artwork.js";
  
  $(drop).css('background-color', original_color);
  
  // Remove existing event handlers to prevent duplicates
  $(drop).off('dragover dragleave drop');
  
  $(drop).on('dragover', (e) => {
    e.stopPropagation();
    e.preventDefault();
    $(drop).css({'border': '2px solid green'});
  });
  
  $(drop).on('dragleave', (e) => {
    $(drop).css({'border': original_border});
  });
  
  $(drop).on('drop', (e) => {
    e.stopPropagation();
    e.preventDefault();
    $(drop).css({'border': '2px solid red'});
    
    var files = e.originalEvent.dataTransfer.files;
    for (var i = 0; i < files.length; i++) {
      var form_data = new FormData();
      form_data.append('item[artworks][]', files[i]);
      form_data.append('item[id]', $(drop).data('item-id'));
    
      $.ajax({
        url: url, 
        type: 'POST',
        data: form_data,
        cache: false,
        contentType: false,
        processData: false,
        complete: function(data) {
          $(drop).css({'border': original_border});
        }
      });
    }
  });
}

function initAllDragDropArtwork() {
  $('li[data-item-id]').each(function() {
    var itemId = $(this).data('item-id');
    if (itemId) {
      initDragDropArtwork(itemId);
    }
  });
}

// Expose globally
window.initDragDropArtwork = initDragDropArtwork;
window.initAllDragDropArtwork = initAllDragDropArtwork;

// Initialize on document ready
$(document).ready(function() {
  if($('.item-form').length > 0) {
    initItemForm();
  }
  // Initialize drag-drop for items
  initAllDragDropArtwork();
});

// Re-initialize on Turbo events
$(document).on('turbo:load turbo:frame-load', function() {
  // Initialize drag-drop for items when Turbo loads content
  initAllDragDropArtwork();
});

// Note: Item form initialization is handled by edit.js.erb when the modal loads via Rails UJS


